import { Link, type LinkProps } from 'react-router';
import { cn } from '@hero/web-lib';
import { Button, type ButtonProps } from './Button';

type ButtonLinkProps = ButtonProps & LinkProps;

const ButtonLink = ({ className, variant, size, to, children, ...props }: ButtonLinkProps) => {
  return (
    <Button asChild variant={variant} size={size} className={cn(className)}>
      <Link to={to} {...props}>
        {children}
      </Link>
    </Button>
  );
};

export default ButtonLink;
